import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useAuth } from "../AuthProvider";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { axiosConfig } from "../axiosAPI";
import PermissionGate from "../components/PermissionGate";
import { hasPermission } from "../utils/permissions";

function Setting() {
  const auth = useAuth();
  const { permissions } = auth;
  const [data, setData] = useState([]);
  const [area, setArea] = useState([]);
  const [governorates, setGovernorates] = useState([]);
  
  // Permission checks for tab visibility
  const canViewGeneral = hasPermission(permissions, 'p_s0001');
  const canUpdateGeneral = hasPermission(permissions, 'p_s0002');
  const canViewDogBreeds = hasPermission(permissions, 'p_db0001');
  const canCreateDogBreeds = hasPermission(permissions, 'p_db0002');
  const canUpdateDogBreeds = hasPermission(permissions, 'p_db0003');
  const canDeleteDogBreeds = hasPermission(permissions, 'p_db0004');
  const canViewAreas = hasPermission(permissions, 'p_ar0001');
  const canCreateAreas = hasPermission(permissions, 'p_ar0002');
  const canUpdateAreas = hasPermission(permissions, 'p_ar0003');
  const canDeleteAreas = hasPermission(permissions, 'p_ar0004');
  const canViewGovernorates = hasPermission(permissions, 'p_g0001');
  const canCreateGovernorates = hasPermission(permissions, 'p_g0002');
  const canUpdateGovernorates = hasPermission(permissions, 'p_g0003');
  const canDeleteGovernorates = hasPermission(permissions, 'p_g0004');
  const [post, setPost] = useState({
    pricePerKilometer: "",
    pricePerMinute: "",
    minFare: "",
    companyPercentage: "",
  });
  const [editRow, setEditRow] = useState(null);
  const [editbreeds, setEditBreeds] = useState();

  const getData = async () => {
    try {
      const response = await axiosConfig.get(
        `${process.env.REACT_APP_BASE_URL}/dog-breeds`,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      setData(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };
  
  const getArea = async () => {
    try {
      const response = await axiosConfig.get(
        `${process.env.REACT_APP_BASE_URL}/areas`,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      setArea(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const getGovernorates = async () => {
    try {
      const response = await axiosConfig.get(
        `${process.env.REACT_APP_BASE_URL}/governorates`,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      setGovernorates(response.data.data || []);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch governorates",
      });
    }
  };

  const createGovernorate = async () => {
    try {
      await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/governorates`,
        governorateForm,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Governorate created successfully",
      });
      getGovernorates();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create governorate",
      });
    } finally {
      resetGovernorateForm();
    }
  };

  const updateGovernorate = async () => {
    if (!editingGovernorateId) return;
    try {
      await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/governorates/${editingGovernorateId}`,
        {
          displayName_Ar: governorateForm.displayName_Ar,
          displayName_En: governorateForm.displayName_En,
        },
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Governorate updated successfully",
      });
      getGovernorates();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update governorate",
      });
    } finally {
      resetGovernorateForm();
    }
  };

  const deleteGovernorate = async (uuid) => {
    try {
      await axiosConfig.delete(
        `${process.env.REACT_APP_BASE_URL}/governorates/${uuid}`,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Governorate removed successfully",
      });
      getGovernorates();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete governorate",
      });
    }
  };


  const [formData, setFormData] = useState({
    displayName_Ar: "",
    displayName_En: "",
    governorateUuid: "",
  });
  const [governorateForm, setGovernorateForm] = useState({
    displayName_Ar: "",
    displayName_En: "",
  });
  const [editingGovernorateId, setEditingGovernorateId] = useState(null);

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setPost({ ...post, [name]: value });
  };  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGovernorateFormChange = (e) => {
    const { name, value } = e.target;
    setGovernorateForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetGovernorateForm = () => {
    setGovernorateForm({
      displayName_Ar: "",
      displayName_En: "",
    });
    setEditingGovernorateId(null);
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();  
    try {
      const payload = {
        displayName_Ar: formData.displayName_Ar,
        displayName_En: formData.displayName_En,
      };
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/dog-breeds`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      getData();
      console.log(response.data);
      } catch (error) {
      console.error( error);
      }
      setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" });
    };

  const deleteUser = uuid => {
    fetch(`${process.env.REACT_APP_BASE_URL}/dog-breeds/${uuid}`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + auth.token,
        "Content-Type": "application/json",
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      },
    })
      .then(response => response.json())
      .then(() => {
        getData()
      })
  }
  
  const editUser = async uuid => {
    const response = await axiosConfig
      .put(
        `${process.env.REACT_APP_BASE_URL}/dog-breeds/` + editbreeds,
        {
          displayName_Ar: formData.displayName_Ar,
          displayName_En: formData.displayName_En,
        },
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      )
      .then((res) => {
        console.log(res);
        getData();
        setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleSubmit2 = async (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    if (!formData.governorateUuid) {
      Swal.fire({
        icon: "warning",
        title: "Governorate Required",
        text: "Please select a governorate before saving the area.",
      });
      return;
    }
    try {
      const payload = {
        displayName_Ar: formData.displayName_Ar,
        displayName_En: formData.displayName_En,
        governorateUuid: formData.governorateUuid,
      };
      const response = await axiosConfig.post(
        `${process.env.REACT_APP_BASE_URL}/areas`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      await getArea();
      console.log(response.data);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Area created successfully",
      });
      setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" });
      setVisible2(false);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to create area",
      });
    }
  };

  const deleteUser2 = uuid => {
    fetch(`${process.env.REACT_APP_BASE_URL}/areas/${uuid}`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + auth.token,
        "Content-Type": "application/json",
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      },
    })
      .then(response => response.json())
      .then(() => {
        getArea()
      })
  }
  
  const editUser2 = async uuid => {
    if (!formData.governorateUuid) {
      Swal.fire({
        icon: "warning",
        title: "Governorate Required",
        text: "Please select a governorate before saving the area.",
      });
      return;
    }
    const payload = {
      displayName_Ar: formData.displayName_Ar,
      displayName_En: formData.displayName_En,
      governorateUuid: formData.governorateUuid,
    };
    try {
      const response = await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/areas/${editRow}`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      console.log(response);
      await getArea();
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Area updated successfully",
      });
      setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" });
      setVisible4(false);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to update area",
      });
    }
  }
  
  const [visible, setVisible] = useState(false);
  const footerContent = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => { handleSubmit(); setVisible(false);}}
        className="save"
        autoFocus
      />
    </div>
  );

  
  const [visible2, setVisible2] = useState(false);
  const footerContent2 = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible2(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => { handleSubmit2(); }}
        className="save"
        autoFocus
      />
    </div>
  );
  
  const [visible3, setVisible3] = useState(false);
  const footerContent3 = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible3(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => { editUser(); setVisible3(false);}}
        className="save"
        autoFocus
      />
    </div>
  );
  
  const [visible4, setVisible4] = useState(false);
  const footerContent4 = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible4(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => { editUser2(); }}
        className="save"
        autoFocus
      />
    </div>
  );

  const [governorateAddVisible, setGovernorateAddVisible] = useState(false);
  const governorateAddFooter = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => {
          setGovernorateAddVisible(false);
          resetGovernorateForm();
        }}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          createGovernorate();
          setGovernorateAddVisible(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  const [governorateEditVisible, setGovernorateEditVisible] = useState(false);
  const governorateEditFooter = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => {
          setGovernorateEditVisible(false);
          resetGovernorateForm();
        }}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          updateGovernorate();
          setGovernorateEditVisible(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  
  const handlePost = async uuid => {
    const response = await axiosConfig
      .put(
        `${process.env.REACT_APP_BASE_URL}/settings`,
        {
          ...post,
          _method: "PUT",
        },
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      )
      .then((res) => {
        console.log(res);
        setPost(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getData();
    getArea();
    getGovernorates();
  }, []);

  useEffect(() => {
    axiosConfig
      .get(`${process.env.REACT_APP_BASE_URL}/settings`, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((response) => {
        setPost(response.data.data);
        console.log(response.data.data);
        console.log(post);
      });
  }, []);

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="setting">
            <Tabs>
              <TabList>
                {canViewGeneral && <Tab>General</Tab>}
                {canViewDogBreeds && <Tab>Dog Breeds</Tab>}
                {canViewAreas && <Tab>Areas</Tab>}
                {canViewGovernorates && <Tab>Governorates</Tab>}
              </TabList>

              {canViewGeneral && (
                <TabPanel>
                  <div className="General">
                    <form>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Price Per Kilometer</label>
                            <input
                              type="number"
                              step={0.1}
                              placeholder="Price Per Kilometer"
                              value={post?.pricePerKilometer}
                              disabled={!canUpdateGeneral}
                              onChange={handleChange2}
                              id="pricePerKilometer"
                              name="pricePerKilometer"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Price Per Minute</label>
                            <input
                              type="number"
                              step={0.1}
                              placeholder="Price Per Minute"
                              value={post?.pricePerMinute}
                              disabled={!canUpdateGeneral}
                              onChange={handleChange2}
                              id="pricePerMinute"
                              name="pricePerMinute"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="form-group">
                            <label>Min Fare</label>
                            <input
                              type="number"
                              step={0.1}
                              placeholder="Min Fare"
                              value={post?.minFare}
                              disabled={!canUpdateGeneral}
                              onChange={handleChange2}
                              id="minFare"
                              name="minFare"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="form-group">
                            <label>Company Percentage</label>
                            <input
                              type="number"
                              step={0.1}
                              placeholder="Company Percentage"
                              value={post?.companyPercentage}
                              disabled={!canUpdateGeneral}
                              onChange={handleChange2}
                              id="companyPercentage"
                              name="companyPercentage"
                            />
                          </div>
                        </div>
                        {canUpdateGeneral && (
                          <div className="col-md-12 text-end mt-5">
                            <a
                              className="save"
                              href="#!"
                              onClick={() => {
                                handlePost();
                              }}
                            >
                              Save
                            </a>
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                </TabPanel>
              )}
              {canViewDogBreeds && (
                <TabPanel>
                  <PermissionGate permission="p_db0002">
                    <a className="add-breeds" onClick={() => { setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" }); setVisible(true); }}>
                      <i className="fa fa-plus"></i>
                    </a>
                  </PermissionGate>
                  <div style={{height: "450px", overflowY: "auto", overflowX: "hidden", marginTop: "20px"}}>
                    {data.map((x, index) => (
                      <div className="breeds mt-3" key={index}>
                        <h4>
                          <span>{x.displayName_Ar}</span> ||{" "}
                          <span>{x.displayName_En}</span>
                        </h4>
                        <div className="actions">
                          <PermissionGate permission="p_db0004">
                            <a
                              href="#!"
                              className="delete"
                              id={x.uuid}
                              onClick={() => deleteUser(x.uuid)}
                            >
                              <i className="fa fa-trash"></i>
                            </a>
                          </PermissionGate>
                          <PermissionGate permission="p_db0003">
                            <a
                              href="#!"
                              className=""
                              id={x.uuid}
                              onClick={() => {
                                setFormData({ displayName_Ar: x.displayName_Ar, displayName_En: x.displayName_En, governorateUuid: "" });
                                setEditBreeds(x.uuid);
                                setVisible3(true);
                              }}
                            >
                              <i className="fa fa-pen"></i>
                            </a>
                          </PermissionGate>
                        </div>
                      </div>
                    ))}
                  </div>
                <Dialog
                  visible={visible}
                  modal
                  footer={footerContent}
                  style={{ width: "50rem" }}
                  onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <label>AR:</label>
                    <input
                      type="text"
                      name="displayName_Ar"
                      value={formData.displayName_Ar}
                      onChange={handleChange}
                    />
                    <br />
                    <label>EN:</label>
                    <input
                      type="text"
                      name="displayName_En"
                      value={formData.displayName_En}
                      onChange={handleChange}
                    />
                    <br />
                    {/* <button>Submit</button> */}
                  </form>
                </Dialog>
                <Dialog
                  visible={visible3}
                  modal
                  footer={footerContent3}
                  style={{ width: "50rem" }}
                  onHide={() => {
                    if (!visible3) return;
                    setVisible3(false);
                  }}
                >
                  <form>
                    <label>AR:</label>
                    <input
                      type="text"
                      name="displayName_Ar"
                      value={formData.displayName_Ar}
                      onChange={handleChange}
                    />
                    <br />
                    <label>EN:</label>
                    <input
                      type="text"
                      name="displayName_En"
                      value={formData.displayName_En}
                      onChange={handleChange}
                    />
                    <br />
                    <label>Governorate:</label>
                    <select
                      name="governorateUuid"
                      value={formData.governorateUuid}
                      onChange={handleChange}
                      className="form-input"
                    >
                      <option value="" disabled>Select governorate</option>
                      {governorates.map((gov) => (
                        <option key={gov.uuid} value={gov.uuid}>
                          {gov.displayName_En || gov.displayName_Ar}
                        </option>
                      ))}
                    </select>
                    <br />
                    {/* <button>Submit</button> */}
                  </form>
                </Dialog>
                </TabPanel>
              )}
              {canViewAreas && (
                <TabPanel>
                  <PermissionGate permission="p_ar0002">
                    <a className="add-breeds" onClick={() => { setFormData({ displayName_Ar: "", displayName_En: "", governorateUuid: "" }); setVisible2(true); }}>
                      <i className="fa fa-plus"></i>
                    </a>
                  </PermissionGate>
                  <div style={{height: "450px", overflowY: "auto", overflowX: "hidden", marginTop: "20px"}}>
                    {area.map((x, index) => {
                      // Get governorate name from governorates array
                      const governorate = governorates.find(gov => gov.uuid === x.governorateUuid);
                      const governorateName = governorate?.displayName_En || governorate?.displayName_Ar || "No Governorate";
                      
                      return (
                        <div className="breeds mt-3" key={index}>
                          <h4>
                            <span>{x.displayName_Ar}</span> ||{" "}
                            <span>{x.displayName_En}</span>
                            <span style={{ marginLeft: "10px", fontSize: "0.9em", color: "#666" }}>
                              ({governorateName})
                            </span>
                          </h4>
                          <div className="actions">
                            <PermissionGate permission="p_ar0004">
                              <a
                                href="#!"
                                className="delete"
                                id={x.uuid}
                                onClick={() => deleteUser2(x.uuid)}
                              >
                                <i className="fa fa-trash"></i>
                              </a>
                            </PermissionGate>
                            <PermissionGate permission="p_ar0003">
                              <a
                                href="#!"
                                className=""
                                id={x.uuid}
                                onClick={() => {
                                  setFormData({ displayName_Ar: x.displayName_Ar, displayName_En: x.displayName_En, governorateUuid: x.governorateUuid || x.governorate?.uuid || "" });
                                  setEditRow(x.uuid);
                                  setVisible4(true);
                                }}
                              >
                                <i className="fa fa-pen"></i>
                              </a>
                            </PermissionGate>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                <Dialog
                  visible={visible2}
                  modal
                  footer={footerContent2}
                  style={{ width: "50rem" }}
                  onHide={() => {
                    if (!visible2) return;
                    setVisible2(false);
                  }}
                >
                  <form onSubmit={handleSubmit2}>
                    <label>AR:</label>
                    <input
                      type="text"
                      name="displayName_Ar"
                      value={formData.displayName_Ar}
                      onChange={handleChange}
                    />
                    <br />
                    <label>EN:</label>
                    <input
                      type="text"
                      name="displayName_En"
                      value={formData.displayName_En}
                      onChange={handleChange}
                    />
                    <br />
                    <label>Governorate:</label>
                    <select
                      name="governorateUuid"
                      value={formData.governorateUuid}
                      onChange={handleChange}
                      className="form-input"
                    >
                      <option value="" disabled>Select governorate</option>
                      {governorates.map((gov) => (
                        <option key={gov.uuid} value={gov.uuid}>
                          {gov.displayName_En || gov.displayName_Ar}
                        </option>
                      ))}
                    </select>
                    <br />
                    {/* <button>Submit</button> */}
                  </form>
                </Dialog>
                <Dialog
                  visible={visible4}
                  modal
                  footer={footerContent4}
                  style={{ width: "50rem" }}
                  onHide={() => {
                    if (!visible4) return;
                    setVisible4(false);
                  }}
                >
                  <form>
                    <label>AR:</label>
                    <input
                      type="text"
                      name="displayName_Ar"
                      value={formData.displayName_Ar}
                      onChange={handleChange}
                    />
                    <br />
                    <label>EN:</label>
                    <input
                      type="text"
                      name="displayName_En"
                      value={formData.displayName_En}
                      onChange={handleChange}
                    />
                    <br />
                    <label>Governorate:</label>
                    <select
                      name="governorateUuid"
                      value={formData.governorateUuid}
                      onChange={handleChange}
                      className="form-input"
                    >
                      <option value="" disabled>Select governorate</option>
                      {governorates.map((gov) => (
                        <option key={gov.uuid} value={gov.uuid}>
                          {gov.displayName_En || gov.displayName_Ar}
                        </option>
                      ))}
                    </select>
                    <br />
                  </form>
                </Dialog>
                </TabPanel>
              )}
              {canViewGovernorates && (
                <TabPanel>
                  <PermissionGate permission="p_g0002">
                    <a
                      className="add-breeds"
                      onClick={() => {
                        resetGovernorateForm();
                        setGovernorateAddVisible(true);
                      }}
                    >
                      <i className="fa fa-plus"></i>
                    </a>
                  </PermissionGate>
                  <div style={{ height: "450px", overflowY: "auto", overflowX: "hidden", marginTop: "20px" }}>
                    {governorates.map((gov, index) => (
                      <div className="breeds mt-3" key={index}>
                        <h4>
                          <span>{gov.displayName_Ar}</span> ||{" "}
                          <span>{gov.displayName_En}</span>
                        </h4>
                        <div className="actions">
                          <PermissionGate permission="p_g0004">
                            <a
                              href="#!"
                              className="delete"
                              id={gov.uuid}
                              onClick={() => deleteGovernorate(gov.uuid)}
                            >
                              <i className="fa fa-trash"></i>
                            </a>
                          </PermissionGate>
                          <PermissionGate permission="p_g0003">
                            <a
                              href="#!"
                              onClick={() => {
                                setGovernorateForm({
                                  displayName_Ar: gov.displayName_Ar,
                                  displayName_En: gov.displayName_En,
                                });
                                setEditingGovernorateId(gov.uuid);
                                setGovernorateEditVisible(true);
                              }}
                            >
                              <i className="fa fa-pen"></i>
                            </a>
                          </PermissionGate>
                        </div>
                      </div>
                    ))}
                  </div>

                  <Dialog
                    visible={governorateAddVisible}
                    modal
                    footer={governorateAddFooter}
                    style={{ width: "50rem" }}
                    onHide={() => {
                      if (!governorateAddVisible) return;
                      setGovernorateAddVisible(false);
                      resetGovernorateForm();
                    }}
                  >
                    <form>
                      <label>AR:</label>
                      <input
                        type="text"
                        name="displayName_Ar"
                        value={governorateForm.displayName_Ar}
                        onChange={handleGovernorateFormChange}
                      />
                      <br />
                      <label>EN:</label>
                      <input
                        type="text"
                        name="displayName_En"
                        value={governorateForm.displayName_En}
                        onChange={handleGovernorateFormChange}
                      />
                      <br />
                    </form>
                  </Dialog>
                  <Dialog
                    visible={governorateEditVisible}
                    modal
                    footer={governorateEditFooter}
                    style={{ width: "50rem" }}
                    onHide={() => {
                      if (!governorateEditVisible) return;
                      setGovernorateEditVisible(false);
                      resetGovernorateForm();
                    }}
                  >
                    <form>
                      <label>AR:</label>
                      <input
                        type="text"
                        name="displayName_Ar"
                        value={governorateForm.displayName_Ar}
                        onChange={handleGovernorateFormChange}
                      />
                      <br />
                      <label>EN:</label>
                      <input
                        type="text"
                        name="displayName_En"
                        value={governorateForm.displayName_En}
                        onChange={handleGovernorateFormChange}
                      />
                      <br />
                    </form>
                  </Dialog>
                </TabPanel>
              )}
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export default Setting;
